/* Licensed Logic · script della landing (06_Landing/index.html). Generato da build_theme.py.
   I bottoni [data-checkout] hanno anche data-add-main: li apre il pannello "Complete your kit" (ll-panel.js). */

/* Solo recensioni vere dei beta tester, con consenso scritto. Formato:
   { text: "…", name: "First name, initial", edition: "Clinical", beta: true, giftCard: true } */
const REVIEWS = [];

/* Varianti di titolo per il message match con le ads: ?angle=retake | real | reflex (default = titolo attuale).
   ?edition=clinical apre la demo sulla domanda Clinical (per le ads rivolte a chi fa il Clinical). */
const ANGLES = {
  retake: { h1: 'Your score report shows where you lost points. <span class="hl">Not why.</span>', sub: 'The Point-Loss Map adds the why: the step you keep breaking, and the drills for it. Built for the 2026 format, Masters and Clinical editions included.' },
  real:   { h1: 'Two answers look right. <span class="hl">One of them only works in the real world.</span>', sub: null },
  reflex: { h1: 'You answer like a real social worker. <span class="hl">On this exam, that costs points.</span>', sub: null }
};

(function(){
  if (!document.getElementById('gal')) return;
  const body = document.body;
  const track = (name, data, custom) => { try { if (window.fbq) fbq(custom ? 'trackCustom' : 'track', name, data || {}); } catch(e){} };
  const params = new URLSearchParams(location.search);

  const ang = ANGLES[(params.get('angle') || '').toLowerCase()];
  if (ang) {
    const h = document.querySelector('[data-angle-h1]'); if (h) h.innerHTML = ang.h1;
    const sb = document.querySelector('[data-angle-sub]'); if (sb && ang.sub) sb.textContent = ang.sub;
  }

  /* bottoni d'acquisto: il pannello apre "Complete your kit"; qui si registra solo il clic */
  document.querySelectorAll('[data-cta]').forEach(a => a.addEventListener('click', () => track('CtaClick', { location: a.dataset.cta || 'other' }, true)));
  /* ViewContent e AddToCart li manda l'app Facebook & Instagram di Shopify (Pixel + CAPI): niente doppioni da qui. */

  /* demo: tab Masters / Clinical */
  function showDemo(ed, fromUser){
    if (ed !== 'clinical') ed = 'masters';
    body.dataset.edition = ed;
    document.querySelectorAll('[data-demo-tab]').forEach(b => b.setAttribute('aria-selected', b.dataset.demoTab === ed ? 'true' : 'false'));
    if (fromUser) track('DemoTab', { edition: ed }, true);
  }
  document.querySelectorAll('[data-demo-tab]').forEach(b => b.addEventListener('click', () => showDemo(b.dataset.demoTab, true)));
  showDemo((params.get('edition') || 'masters').toLowerCase(), false);

  /* gallery */
  const gal = document.getElementById('gal'), thumbs = [...document.querySelectorAll('#thumbs button')];
  thumbs.forEach((b, i) => b.addEventListener('click', () => { gal.scrollTo({ left: gal.clientWidth * i, behavior: 'smooth' }); }));
  let t; gal.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(() => { const i = Math.round(gal.scrollLeft / gal.clientWidth); thumbs.forEach((b, j) => b.setAttribute('aria-current', j === i ? 'true' : 'false')); }, 60); });

  /* decoder demo */
  document.querySelectorAll('[data-demo]').forEach(demo => {
    const key = demo.dataset.key;
    function reveal(picked){
      if(demo.classList.contains('revealed')) return;
      demo.querySelectorAll('.opt').forEach(o => o.classList.add(o.dataset.l === key ? 'correct' : 'wrong'));
      demo.classList.add('revealed');
      track('DemoAnswer', { edition: body.dataset.edition, answered: picked || 'none', correct: picked ? picked === key : null }, true);
    }
    demo.querySelectorAll('.opt').forEach(o => o.addEventListener('click', () => { o.setAttribute('aria-pressed', 'true'); reveal(o.dataset.l); }));
    demo.querySelectorAll('[data-reveal]').forEach(b => b.addEventListener('click', () => reveal(null)));
  });

  /* reviews: compaiono solo con recensioni vere */
  if(REVIEWS.length){
    const wrap = document.getElementById('revs');
    REVIEWS.forEach(r => {
      const d = document.createElement('div'); d.className = 'rev';
      const p = document.createElement('p'); p.textContent = '"' + r.text + '"';
      const w = document.createElement('div'); w.className = 'who'; w.textContent = r.name + (r.edition ? ' · ' + r.edition : '');
      d.append(p, w);
      if(r.beta){ const b = document.createElement('span'); b.className = 'badge'; b.textContent = 'Beta tester · got the system free' + (r.giftCard ? ' and a gift card' : ''); d.append(b); }
      wrap.append(d);
    });
    if(REVIEWS.some(r => r.beta)) document.getElementById('revnote').textContent = 'Beta testers received the system free' + (REVIEWS.some(r => r.giftCard) ? ' and a small gift card' : '') + ', whatever their review said.';
    document.getElementById('reviews').hidden = false;
  }

  /* sticky bar: visibile quando né il bottone dell'hero né il box d'acquisto 2 sono a schermo */
  const sticky = document.getElementById('sticky');
  const heroCta = document.querySelector('.hero-info .btn-buy'), buy2 = document.querySelector('.buy2');
  const seen = new Map([[heroCta, true], [buy2, false]]);
  const io = new IntersectionObserver(es => {
    es.forEach(e => seen.set(e.target, e.isIntersecting));
    const show = !seen.get(heroCta) && !seen.get(buy2);
    sticky.classList.toggle('show', show);
    sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    sticky.querySelector('a').tabIndex = show ? 0 : -1;
  });
  [heroCta, buy2].forEach(el => el && io.observe(el));
})();
